import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/ViewSku7Master';


const ViewSku7Master = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">SKU7 MASTER - View</h3>
      </Col>
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

  </Container>
);

ViewSku7Master.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(ViewSku7Master);
